"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "14px",
    lineHeight: "24px",
    fontWeight: "bold",
    color: theme.palette.text.secondary
  }
}));

const ModuleStatus = ({
  component = "h3",
  status,
  children
}) => {
  const classes = useStyles();

  if (!status && children) {
    status = children;
  }

  if (!status) {
    return false;
  }

  return _react.default.createElement(_Typography.default, {
    className: classes.root,
    noWrap: true,
    component: component
  }, status);
};

ModuleStatus.propTypes = process.env.NODE_ENV !== "production" ? {
  status: _propTypes.default.string
} : {};
var _default = ModuleStatus;
exports.default = _default;
module.exports = exports.default;